import React from 'react'
import Classes from '../Information.module.css'
const PlusIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function PersonalInfo({ handleNext, formData, setFormData }) {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const addAlternativeName = () => {
    setFormData({ ...formData, alternativeNames: [...formData.alternativeNames, ''] });
  };

  const handleAlternativeNameChange = (index, value) => {
    const newNames = [...formData.alternativeNames];
    newNames[index] = value;
    setFormData({ ...formData, alternativeNames: newNames });
  };

  return (
    <>
      <div className={Classes.infoCon} >
        <div>
          <h3>Personal Information</h3>
        </div>
        <div className={Classes.infoConMiddle} >
          <div className={Classes.flexColGroup} >
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >First Name (required)</h5>
              <input
                type='text'
                name='firstName'
                value={formData.firstName}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='John'
              />
            </div>
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Last Name (required)</h5>
              <input
                type='text'
                name='lastName'
                value={formData.lastName}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='Doe'
              />
            </div>
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Phone Number</h5>
              <input
                type='number'
                name='phoneNumber'
                value={formData.phoneNumber}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='+1 234 567 8900'
              />
            </div>
          </div>
          <div className={Classes.textInstructions} >
            <h5 className={`${Classes.textBold} mb-10`} >Alternative names or (mis)spellings</h5>
            <h5 className={Classes.text} > Many people don’t have any, but feel free to add any, especially if: </h5>
            <ul className={Classes.customUl} >
              <li> <h5 className={Classes.text} > Your name is often misspelled (add the common mistakes - first or last) </h5> </li>
              <li> <h5 className={Classes.text} > You got married or divorced and changed your name </h5> </li>
              <li> <h5 className={Classes.text} > You have a name but you go by something different </h5> </li>
            </ul>
          </div>
          <div className={Classes.flexAlign10} style={{ cursor: 'pointer' }} onClick={addAlternativeName} >
            <PlusIcon height='17px' width='17px' fill='#006B32' />
            <h5 className={Classes.coloredText} >Add Alternative Name</h5>
          </div>
          {formData.alternativeNames.map((name, index) => (
            <input
              key={index}
              type='text'
              value={name}
              onChange={(e) => handleAlternativeNameChange(index, e.target.value)}
              className={Classes.inputField}
              placeholder='Alternative Name'
            />
          ))}
          <hr className={Classes.line} />
          <div className={Classes.flexColGroup} >
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Email (optional)</h5>
              <input
                type='email'
                name='email'
                value={formData.email}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='example@mail.com'
              />
            </div>
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Date of Birth (optional)</h5>
              <input
                type='date'
                name='dateOfBirth'
                value={formData.dateOfBirth}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='01-01-2000'
              />
            </div>
            <div className={Classes.flexCol1} >
              <h5 className={Classes.label} >Gender (optional)</h5>
              <select
                name='gender'
                value={formData.gender}
                onChange={handleChange}
                className={Classes.inputField}
                placeholder='Gender (optional)'
              >
                <option value=''>Select Gender</option>
                <option value='Male'>Male</option>
                <option value='Female'>Female</option>
                <option value='Other'>Other</option>
              </select>
            </div>
          </div>
        </div>
        <div>
          <div className={Classes.flexEnd} >
            <div className={Classes.flexAlign10} >
              <button className={Classes.nextBtn} onClick={handleNext} > <h5>Next</h5> </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}